<template>
  <div class="basicData_box">
    <el-card shadow="always">
      <div>
        <el-radio-group v-model="radio" size="medium">
          <el-radio-button label="1">退费原因</el-radio-button>
          <el-radio-button label="2">反馈渠道</el-radio-button>
          <el-radio-button label="3">项目类型</el-radio-button>
        </el-radio-group>
      </div>
      <div class="basicData_top">
        <el-form
          ref="formInline"
          :inline="true"
          size="medium"
          :model="formInline"
        >
          <el-form-item
            :label="
              radio === '1'
                ? '退费原因'
                : radio === '2'
                ? '反馈渠道'
                : radio === '3'
                ? '项目类型'
                : ''
            "
            prop="description"
          >
            <el-input
              v-model="formInline.description"
              clearable
              :placeholder="
                radio === '1'
                  ? '请输入退费原因'
                  : radio === '2'
                  ? '请输入反馈渠道'
                  : radio === '3'
                  ? '请输入项目类型'
                  : ''
              "
            ></el-input>
          </el-form-item>
          <el-form-item style="margin-left: 40px">
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="basicData_title">
        <el-button type="primary" size="medium" @click="openDialog"
          >新增</el-button
        >
      </div>

      <div class="basicData_table">
        <el-table
          v-loading="loading"
          border
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            prop="sortNum"
            align="center"
            label="序号"
            width="140"
          >
          </el-table-column>
          <el-table-column
            prop="description"
            align="center"
            :label="
              radio === '1'
                ? '退费原因'
                : radio === '2'
                ? '反馈渠道'
                : radio === '3'
                ? '项目类型'
                : ''
            "
          >
          </el-table-column>
          <el-table-column
            prop="status"
            align="center"
            label="状态"
            width="280"
          >
            <template slot-scope="scope">
              <el-tag size="medium" v-if="scope.row.status === 1"
                >已启用</el-tag
              >
              <el-tag
                size="medium"
                type="danger"
                v-else-if="scope.row.status === 2"
                >已停用</el-tag
              >
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="240">
            <template slot-scope="scope">
              <span
                class="blue_Box"
                v-if="scope.row.status === 2"
                @click="handleEnable(scope.row, 1)"
                >启用</span
              >
              <span
                class="blue_Box"
                v-else-if="scope.row.status === 1"
                @click="handleEnable(scope.row, 2)"
                >停用</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />

      <el-dialog
        :title="radio === '1'
                ? '添加退费原因'
                : radio === '2'
                ? '添加反馈渠道'
                : radio === '3'
                ? '添加项目类型'
                : ''"
        :visible.sync="dialogVisible"
        width="500px"
        :before-close="handleClose"
      >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          size="medium"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item
            :label="
              radio === '1'
                ? '退费原因'
                : radio === '2'
                ? '反馈渠道'
                : radio === '3'
                ? '项目类型'
                : ''
            "
            prop="description"
          >
            <el-input
              v-model.trim="ruleForm.description"
              maxlength="30"
              :placeholder="
                radio === '1'
                  ? '请输入退费原因'
                  : radio === '2'
                  ? '请输入反馈渠道'
                  : radio === '3'
                  ? '请输入项目类型'
                  : ''
              "
            ></el-input>
          </el-form-item>
          <el-form-item label="排序号" prop="sortNum">
            <el-input
              v-model="ruleForm.sortNum"
              @input="sortNumValueInput"
              placeholder="请输入排序号"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="medium" @click="handleClose">取消</el-button>
          <el-button size="medium" type="primary" @click="handleAffirm"
            >保存</el-button
          >
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  getRefundBaseDataListPage,
  updateRefundBaseDataStatus,
  addRefundBaseData,
} from "@/api/refund/index.js";
import myPagination from "@/components/myPagination.vue";
import { clone, processing } from "@/utils/handle.js";
export default {
  components: { myPagination },
  data() {
    const valiDescription = (rule, value, callback) => {
      if (value === "") {
        if (this.radio === "1") {
          callback(new Error("请输入退费原因"));
        } else if (this.radio === "2") {
          callback(new Error("请输入反馈渠道"));
        } else if (this.radio === "3") {
          callback(new Error("请输入项目类型"));
        }
      } else {
        callback();
      }
    };
    return {
      loading: false,
      radio: localStorage.getItem("BasicDataRadio") || "1",
      formInline: {
        description: "",
      },
      dialogVisible: false,
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      tableData: [],
      ruleForm: {
        description: "",
        sortNum: "",
      },
      rules: {
        description: [
          { required: true, validator: valiDescription, trigger: "blur" },
        ],
        sortNum: [{ required: true, message: "请输入排序号", trigger: "blur" }],
      },
      searchData: {},
    };
  },
  watch: {
    radio: {
      handler(to) {
        this.searchData = {};
        this.formInline.description = "";
        this.getRefundBaseDataListPage({
          type: to,
          page: 1,
          limit: 10,
        });
        localStorage.setItem("BasicDataRadio", to);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async getRefundBaseDataListPage(payload) {
      this.loading = true;
      this.$set(this.pageInfo, "page", payload.page);
      this.$set(this.pageInfo, "limit", payload.limit);
      const res = await getRefundBaseDataListPage(payload);
      this.tableData = res.data.records || [];
      this.pageInfo.total = Number(res.data.total) || 0;
      this.loading = false;
    },
    // 表单项目识别码校验
    sortNumValueInput(payload) {
      payload = payload.replace(/[^0-9]/g, "");
      payload = payload === "" ? payload : Number(payload);
      this.$nextTick(() => {
        this.$set(this.ruleForm, "sortNum", payload);
      });
    },
    openDialog() {
      this.ruleForm = {
        description: "",
        sortNum: "",
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs["ruleForm"].clearValidate();
      });
    },
    handleAffirm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          addRefundBaseData({ ...clone(this.ruleForm), type: this.radio }).then(
            (res) => {
              if (res.code === 0) {
                this.$message({
                  type: "success",
                  message: "添加成功!",
                });
                this.refresh();
                this.dialogVisible = false;
              }
            }
          );
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 查询
    handleSearch() {
      this.searchData = processing(this.formInline);
      this.getRefundBaseDataListPage({
        type: this.radio,
        page: this.pageInfo.page,
        limit: this.pageInfo.limit,
        ...clone(this.searchData),
      });
    },
    // 重置
    handleReset() {
      this.searchData = {};
      this.$refs["formInline"].resetFields();
      this.getRefundBaseDataListPage({
        type: this.radio,
        page: 1,
        limit: 10,
      });
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getRefundBaseDataListPage({
        type: this.radio,
        page: payload,
        limit: this.pageInfo.limit,
        ...clone(this.searchData),
      });
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getRefundBaseDataListPage({
        type: this.radio,
        page: 1,
        limit: payload,
        ...clone(this.searchData),
      });
    },
    // 修改状态
    handleEnable(payload, status) {
      let str = status === 1 ? "启用" : "停用";
      this.$confirm(`确认要${str}吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        updateRefundBaseDataStatus({ id: payload.id, status: status }).then(
          (res) => {
            if (res.code === 0) {
              this.$message({
                type: "success",
                message: `${str}成功!`,
              });
              this.refresh();
            }
          }
        );
      });
    },
    // 刷新
    refresh() {
      this.getRefundBaseDataListPage({
        type: this.radio,
        page: this.pageInfo.page,
        limit: this.pageInfo.limit,
        ...clone(this.searchData),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.basicData_box {
  .basicData_top {
    margin-top: 24px;
  }
  .basicData_title {
    margin-bottom: 14px;
  }
  .basicData_table {
    .blue_Box {
      margin: 0 6px;
      color: #2d8cf0;
      cursor: pointer;
    }
    .blue_Box:hover {
      color: #57a3f4;
    }
  }
}
</style>